<template>
  <AppHeader>Report</AppHeader>

  <div class="p-4">
    <div class="flex flex-col text-lg bg-white shadow rounded-2xl divide-y-2 divide-slate-100">
      <router-link :to="{name: 'ReportCustomerSummary'}" class="px-3 py-2">Customer Milk Delivery Summary</router-link>
      <router-link :to="{name: 'ReportCommission'}" class="px-3 py-2">Commission Report</router-link>
      <router-link :to="{name: 'ReportTransactions'}" class="px-3 py-2">Old Dealer Transactions</router-link>
      <router-link :to="{name: 'ReportEmptyBottleSummary'}" class="px-3 py-2">Empty Bottle Summary</router-link>
      <router-link :to="{name: 'ReportPendingBottleReturnSummary', params: { date: new Date().toISOString().slice(0,10) }}" class="px-3 py-2">Pending Bottle Return Summary</router-link>
      <router-link :to="{name: 'ReportPendingBottleReturnAllSummary'}" class="px-3 py-2">Pending Bottle Return All Summary</router-link>
      <router-link :to="{name: 'ReportCrateSummary'}" class="px-3 py-2">Crate Summary</router-link>
      <router-link :to="{name: 'ReportLowBalance'}" class="px-3 py-2">Customer Low Balance</router-link>
      <router-link :to="{name: 'ReportDealerTnxSummary'}" class="px-3 py-2">Dealer Transaction Summary</router-link>
      <router-link :to="{name: 'ReportDealerSampleSlot'}" class="px-3 py-2">Dealer Sample Slots</router-link>
      <router-link :to="{name: 'ReportDeliveryPersonsAttendanceSummary'}" class="px-3 py-2">Delivery Person Attendance Summary</router-link>
      <router-link :to="{name: 'ReportDeliveryPersonsTransactionSummary'}" class="px-3 py-2">Delivery Person Transaction Summary</router-link>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/common/Header.vue';
import mixin from '@/utils/mixin.js';

export default {
  name: 'Reports',
  components: { AppHeader },
  mixins: [ mixin ],
  created() {
    if (!this.$store.state.api_token) this.$router.push('/');
  }
}
</script>
